// Static demo data for the monitoring pages, ported verbatim from the
// AuditHippo-pages prototype (automation-health.html, journey-health.html,
// subscriber-health.html, bu-comparison.html + scripts.js).
//
// These screens have no backend endpoints yet. Keeping the fixtures in one
// module means swapping them for API calls later touches this file only.

/* ===== BUSINESS UNITS (scripts.js: AUDIT_BUSINESS_UNITS) ===== */

export const BUSINESS_UNITS = [
    { id: 'irobot',       name: 'iRobot',              mid: '514014416', parent: true },
    { id: 'analytics',    name: 'iRobot_Analytics',    mid: '514014505' },
    { id: 'customercare', name: 'iRobot_CustomerCare', mid: '514014504' },
    { id: 'ecommerce',    name: 'iRobot_Ecommerce',    mid: '514014502' },
    { id: 'loyalty',      name: 'iRobot_Loyalty',      mid: '514014503' },
    { id: 'marketing',    name: 'iRobot_Marketing',    mid: '514014501' },
    { id: 'sandbox',      name: 'iRobot_Sandbox',      mid: '514014506' },
];

/* ===== CROSS-BU COMPARISON (scripts.js: BU_COMPARISON_DATA) ===== */

export const BU_COMPARISON_DATA = {
    irobot:       { des: 28, automations: 9, autoError: 2, journeys: 12, journeysActive: 9, sendable: 14, criticalPii: 4, subscribers: 487400, hardBounce: 1842, sharedDes: 6 },
    marketing:    { des: 10, automations: 3, autoError: 1, journeys: 4,  journeysActive: 3, sendable: 6,  criticalPii: 1, subscribers: 84200,  hardBounce: 310,  sharedDes: 2 },
    ecommerce:    { des: 8,  automations: 2, autoError: 0, journeys: 3,  journeysActive: 2, sendable: 4,  criticalPii: 0, subscribers: 62300,  hardBounce: 188,  sharedDes: 1 },
    loyalty:      { des: 12, automations: 4, autoError: 1, journeys: 5,  journeysActive: 4, sendable: 7,  criticalPii: 2, subscribers: 89100,  hardBounce: 421,  sharedDes: 3 },
    customercare: { des: 14, automations: 5, autoError: 2, journeys: 6,  journeysActive: 3, sendable: 5,  criticalPii: 1, subscribers: 41200,  hardBounce: 980,  sharedDes: 1 },
    analytics:    { des: 7,  automations: 2, autoError: 0, journeys: 2,  journeysActive: 1, sendable: 2,  criticalPii: 0, subscribers: 15600,  hardBounce: 44,   sharedDes: 4 },
    sandbox:      { des: 16, automations: 6, autoError: 3, journeys: 7,  journeysActive: 0, sendable: 8,  criticalPii: 3, subscribers: 2100,   hardBounce: 12,   sharedDes: 0 },
};

/* ===== AUTOMATION HEALTH (automation-health.html) ===== */

export const AUTOMATION_STATUS_COLORS = {
    'Running':   '#6366F1',
    'Error':     '#EF4444',
    'Never Run': '#64748B',
    'Stale':     '#F59E0B',
    'Paused':    '#F59E0B',
    'Stopped':   '#64748B',
    'Success':   '#10B981',
};

export const AUTOMATION_BADGE_CLASS = {
    'Running':   'ah-badge-running',
    'Error':     'ah-badge-error',
    'Never Run': 'ah-badge-never-run',
    'Stale':     'ah-badge-stale',
    'Paused':    'ah-badge-paused',
    'Stopped':   'ah-badge-never-run',
    'Success':   'ah-badge-success',
};

export const AUTOMATION_HEALTH_ROWS = [
    { status: 'Running',   name: 'CartAbandon_Audience_Build',  lastRun: 'In progress · started 4m ago', lastRunLabel: 'In progress', lastRunColor: '#6366F1', duration: '4m 02s', nextRun: '—',                  folder: 'Automations/Lifecycle',    journey: 'Abandoned Cart',           steps: 3 },
    { status: 'Error',     name: 'SFMC_DataView_Extract',       lastRun: 'Today 4:12 AM',                lastRunColor: '#DC2626', duration: '1m 08s', nextRun: 'Tomorrow 4:00 AM',   folder: 'Automations/Admin',        journey: 'Platform Admin',           steps: 2,
      error: '_Sent Data View timed out after 60s. Query exceeded the 20-minute limit on the last SQL step.' },
    { status: 'Never Run', name: 'Welcome_SMS_OptIn_Sync',      lastRun: 'Never',                        duration: '—',      nextRun: 'Not scheduled',      folder: 'Automations/Welcome',      journey: 'Welcome Series',           steps: 2 },
    { status: 'Stale',     name: 'Quarterly_Consent_Refresh',   lastRun: 'Jan 10, 2026 6:00 AM',         duration: '6m 44s', nextRun: 'Apr 10, 6:00 AM',    folder: 'Automations/Compliance',   journey: 'Preference Centre',        steps: 3 },
    { status: 'Paused',    name: 'Legacy_Catalog_Import',       lastRun: 'Feb 2, 2026 1:15 AM',          duration: '3m 21s', nextRun: '—',                  folder: 'Automations/Catalog',      journey: 'Product Feed',             steps: 2 },
    { status: 'Stopped',   name: 'Old_Journey_Cleanup',         lastRun: 'Dec 18, 2025 11:00 PM',        duration: '8m 05s', nextRun: '—',                  folder: 'Automations/Maintenance',  journey: '—',                        steps: 4 },
    { status: 'Success',   name: 'Welcome_DataRefresh_Auto',    lastRun: 'Today 3:00 AM',                duration: '2m 18s', nextRun: 'Tomorrow 3:00 AM',   folder: 'Automations/Welcome',      journey: 'Welcome Series',           steps: 3 },
    { status: 'Success',   name: 'PostPurchase_Nightly_Sync',   lastRun: 'Today 2:00 AM',                duration: '4m 12s', nextRun: 'Tomorrow 2:00 AM',   folder: 'Automations/Transactional', journey: 'Post-Purchase Follow Up', steps: 3 },
    { status: 'Success',   name: 'Birthday_Daily_Injection',    lastRun: 'Today 12:01 AM',               duration: '0m 39s', nextRun: 'Tomorrow 12:01 AM',  folder: 'Automations/Birthday',     journey: 'Birthday Journey',         steps: 2 },
    { status: 'Success',   name: 'ReEngage_Weekly_Refresh',     lastRun: 'Mar 7, 6:00 AM',               duration: '2m 41s', nextRun: 'Mar 14, 6:00 AM',    folder: 'Automations/ReEngagement', journey: 'Re-engagement Campaign',   steps: 2 },
];

/* ===== JOURNEY HEALTH (journey-health.html) ===== */

export const JOURNEY_STATUS_COLORS = {
    Active:  '#10B981',
    Paused:  '#F59E0B',
    Draft:   '#6366F1',
    Stopped: '#475569',
};

export const JOURNEY_BADGE_CLASS = {
    Active:  'ah-badge-success',
    Paused:  'ah-badge-paused',
    Draft:   'ah-badge-draft',
    Stopped: 'ah-badge-never-run',
};

// `health` drives the KPI-card filters; `stripe` overrides the status colour
// where the prototype flagged a row as unhealthy.
export const JOURNEY_HEALTH_ROWS = [
    { status: 'Active',  health: ['ActiveInFlight', 'GoalNotMet'], name: 'Loyalty Winback Test',      contacts: '842',   goal: '6.4%', goalColor: '#DC2626', published: 'Jan 20, 2026',   entry: 'Audience / Loyalty_Lapsed',          folder: 'Journeys/Loyalty',        stripe: '#EF4444' },
    { status: 'Active',  health: ['ZeroContacts'],                 name: 'Abandoned Cart Rescue',     contacts: '0',     goal: '42%',  published: 'Feb 12, 2026',   entry: 'API Event / CartAbandon',           folder: 'Journeys/Lifecycle',      stripe: '#64748B' },
    { status: 'Draft',   health: ['Unpublished'],                  name: 'SMS Preference Onboarding', contacts: '0',     goal: '—',    published: 'Never published', entry: 'API Event / SMS_OptIn',            folder: 'Journeys/Drafts',         stripe: '#6366F1' },
    { status: 'Stopped', health: [],                               name: 'Old Catalog Nurture',       contacts: '0',     goal: '18%',  published: 'Dec 3, 2025',    entry: 'Audience / Catalog_Nurture',        folder: 'Journeys/Archive',        stripe: '#475569' },
    { status: 'Active',  health: ['ActiveInFlight'],               name: 'Welcome Series',            contacts: '24.6K', goal: '78%',  published: 'Mar 5, 2026',    entry: 'Audience / WelcomeSeries_Contacts', folder: 'Journeys/Welcome',        stripe: '#10B981' },
    { status: 'Active',  health: ['ActiveInFlight'],               name: 'Re-engagement Campaign',    contacts: '26.6K', goal: '54%',  published: 'Feb 28, 2026',   entry: 'Audience / ReEngagement_Lapsed',    folder: 'Journeys/ReEngagement',   stripe: '#10B981' },
    { status: 'Active',  health: ['ActiveInFlight'],               name: 'Birthday Journey',          contacts: '1.4K',  goal: '96%',  published: 'Mar 1, 2026',    entry: 'Audience / Birthday_Eligible',      folder: 'Journeys/Birthday',       stripe: '#10B981' },
    { status: 'Paused',  health: [],                               name: 'Post-Purchase Follow Up',   contacts: '5.3K',  goal: '97%',  published: 'Jan 14, 2026',   entry: 'Audience / PostPurchase_Buyers',    folder: 'Journeys/Transactional',  stripe: '#F59E0B' },
];

/* ===== SUBSCRIBER HEALTH (subscriber-health.html) ===== */

export const SUBSCRIBER_HEALTH = {
    kpis: {
        active:      { value: '412.5K', subtext: 'active, no bounce or unsub' },
        hardBounced: { value: '8.6K',   subtext: 'hard bounce on record' },
        unsubscribed:{ value: '18.9K',  subtext: 'across all lists' },
        suppressed:  { value: '4.9K',   subtext: 'currently on any list' },
    },
    totalSubscribers: '448.2K',
    bounces: {
        hardWidth: 37.8,
        softWidth: 62.2,
        rows: [
            { label: 'Hard bounces', color: '#EF4444', count: '8,640',  pct: '1.9% of total' },
            { label: 'Soft bounces', color: '#F59E0B', count: '14,210', pct: '3.2% of total' },
        ],
    },
    unsubTrend: [
        { period: 'Last 30 days', count: '1,284', width: 31 },
        { period: 'Last 60 days', count: '2,610', width: 62 },
        { period: 'Last 90 days', count: '4,186', width: 100 },
    ],
    suppressionLists: [
        { name: 'WelcomeSeries_Exclusions', count: '3,214', modified: 'Yesterday',     folder: 'Marketing/Suppression', used: 'Welcome Series', type: 'Auto-suppression DE', stripe: '#8B5CF6', countColor: '#7C3AED' },
        { name: 'Global_Unsubscribe',       count: '1,140', modified: 'Mar 12, 2026',  folder: 'Marketing/Suppression', used: 'All journeys',   type: 'Publication list',    stripe: '#EF4444' },
        { name: 'Legal_Hold_Suppress',      count: '286',   modified: 'Feb 4, 2026',   folder: 'Marketing/Compliance',  used: 'Legal hold',     type: 'Manual list',         stripe: '#F59E0B' },
        { name: 'Complaint_AutoSuppress',   count: '234',   modified: 'Today 8:10 AM', folder: 'Marketing/Suppression', used: 'Feedback loop',  type: 'Auto-suppression',    stripe: '#64748B' },
    ],
    inactive: {
        count: '61.8K',
        caption: 'inactive of 448.2K total',
        pct: '13.8%',
        barWidth: 13.8,
        note: 'These contacts are still Active in All Subscribers, but have not engaged in 90 days. Consider a re-engagement journey or suppression.',
    },
};
